import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
/**
 * Componente del modal de resumen una vez que se agrega la cuenta
 */
@Component({
  standalone: false,
  selector: 'app-modal-summary',
  templateUrl: './modal-summary.component.html',
  styleUrls: ['./modal-summary.component.scss']
})
export class ModalSummaryComponent implements OnInit {

  /**
   * Crea una instancia para modal summary component.
   * @param dialogRef 
   * @param r 
   */
  constructor(public dialogRef: MatDialogRef<ModalSummaryComponent>, private readonly r: Router) {
  }

  /**
   * on init
   */
  ngOnInit() {
  }

  /**
   * Cierra el modal
   */
  closeModal() {
    this.dialogRef.close();
  }

  /**
   * Cierra el modal y redirige a las FAQ
   */
  goToUrl() {
    this.closeModal();
    this.r.navigateByUrl('global-position/faqs-client');
  }
}
